import React, { useState, useEffect } from 'react';
import DeviceList from './DeviceList';
import DeviceDetail from './DeviceDetail';

interface Device {
  id: string;
  customerId: string;
  model: string;
  serialNumber: string;
  warrantyExpires: string | null;
  invoiceNumber: string | null;
  invoiceDate: string | null;
  country: string | null;
  comments: string | null;
  customerName: string;
  customerEmail: string;
  customerCountry: string | null;
  companyName?: string;
  ticketCount: number;
  serviceCount: number;
  linkedTickets: Array<{
    id: string;
    ticketNumber: string;
    title: string;
    status: string;
    createdAt: string;
  }>;
  createdAt: string;
  updatedAt: string;
}

interface DeviceManagementProps {
  onTicketSelect?: (ticketId: string) => void;
  initialDevice?: Device; // Device to pre-select and show details for
}

const DeviceManagement: React.FC<DeviceManagementProps> = ({ onTicketSelect, initialDevice }) => {
  const [selectedDevice, setSelectedDevice] = useState<Device | null>(null);

  // Handle initial device selection
  useEffect(() => {
    if (initialDevice) {
      setSelectedDevice(initialDevice);
    }
  }, [initialDevice]);

  const handleDeviceSelect = (device: Device) => {
    setSelectedDevice(device);
  };

  const handleBackToList = () => {
    setSelectedDevice(null);
  };

  const handleTicketSelect = (ticketId: string) => {
    if (onTicketSelect) {
      onTicketSelect(ticketId);
    }
  };

  if (selectedDevice) {
    return (
      <DeviceDetail
        device={selectedDevice}
        onBack={handleBackToList}
        onTicketSelect={handleTicketSelect}
      />
    );
  }

  return (
    <DeviceList onDeviceSelect={handleDeviceSelect} />
  );
};

export default DeviceManagement; 